/* ################################################################### */
/*
/*  Root components file
/*
/* ################################################################### */

/* ------------------------------------------------------------------- */
/*                              Import
/* ------------------------------------------------------------------- */

import Breadcrumbs from './Breadcrumbs';

/* ------------------------------------------------------------------- */
/*                              Export
/* ------------------------------------------------------------------- */

export {
  Breadcrumbs
};
